// src/lib/device.js
// import { writable } from "svelte/store";

// export const isMobile = writable(false);

// function detectDevice() {
//     const mobile = window.matchMedia("(max-width: 768px)").matches;
//     isMobile.set(mobile);
// }

// // detect khi load
// if (typeof window !== "undefined") {
//     detectDevice();
//     window.addEventListener("resize", detectDevice);
// }

import { writable } from 'svelte/store';

export const isMobile = writable(false);
export const isLandscape = writable(false);
export const isTouch = writable(false);

function detectDevice() {
    const width = window.innerWidth;
    const height = window.innerHeight;

    const landscape = width > height;
    isLandscape.set(landscape);

    // Mobile thực sự = nhỏ + dọc
    const mobile = width < 768 && !landscape;

    isMobile.set(mobile);

    isTouch.set(
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0
    );
}

if (typeof window !== 'undefined') {
    detectDevice();

    window.addEventListener('resize', detectDevice);
    window.addEventListener('orientationchange', detectDevice);
}
